import useWorkspaceContext from "@/hooks/useWorkspaceContext"
import { workspaceAvatarColors } from "@/utils/workspaceBranding"
import { otherActiveWorkspaces } from "@/utils/workspaceMemberships"
import { Avatar, HStack, Link as ChakraLink, Text, VStack } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

const rootDomain = process.env.NEXT_PUBLIC_ROOT_DOMAIN as string

const WorkspaceSwitcher = ({
  px = 4,
  onNavigate,
}: {
  px?: number
  onNavigate?: () => void
}) => {
  const { t } = useTranslation()
  const { current, myWorkspaces } = useWorkspaceContext()
  const others = otherActiveWorkspaces(myWorkspaces, current?.subdomain)

  if (!others.length) {
    return null
  }

  return (
    <VStack align="stretch" spacing={0} px={px} pb={4} width="100%">
      <Text fontSize="xs" color="secondary.dark" px={2} pb={1}>
        {t("workspace.switcher.label")}
      </Text>
      {others.map((membership) => {
        const { bg, color } = workspaceAvatarColors(membership.workspace)

        return (
          <ChakraLink
            key={membership.workspace.subdomain}
            href={`https://${membership.workspace.subdomain}.${rootDomain}`}
            onClick={onNavigate}
            padding={2}
            transition="background 0.2s ease-in-out"
            _hover={{ bg: "surface", textDecoration: "none" }}
          >
            <HStack>
              <Avatar
                size="xs"
                name={membership.workspace.name}
                src={membership.workspace.logo?.url}
                bg={bg}
                color={color}
              />
              <Text fontSize="sm">{membership.workspace.name}</Text>
            </HStack>
          </ChakraLink>
        )
      })}
    </VStack>
  )
}

export default WorkspaceSwitcher
